import $ from 'jquery'

/*************************************************************
 *************    Initializing Functions    ****************
 *************************************************************/

import headerMenu from "./modules/header-menu"
import anchorScroll from "./modules/anchor-scroll"
import cookieConsent from "./modules/cookieconsent"
import singleRegija from "./modules/single-regija"
import filtersMobileToggle from "./modules/filters-mobile"
import mobileMenu from "./modules/mobile-menu"
import homeNewsSlick from "./modules/home-news-slick"
import viviSelect from "./modules/vivi-select"
import restavracijeLoad from "./modules/restavracije-load"
import restavracijeGallerySlick from "./modules/restavracije-gallery-slick"
// import restavracijaInviteSlick from "./modules/restavracija-invite-slick"
import restavracijaHeaderSlick from "./modules/restavracija-header-slick"
import restavracijaFlotingButton from "./modules/restavracija-floating-button"
import restavracijaTRmenu from "./modules/restavracija-tr-menu"
import restavracijaPopupForm from "./modules/restavracija-popup-form"
import restavracijaGalleryMagnific from "./modules/restavracija-gallery-magnific"
import newsLoad from "./modules/news-load"
import chefsLoad from "./modules/chefs-load"
import intersectionAnimations from "./modules/intersection-animations"
import infoPopup from "./modules/info-popup"
import filterExpander from "./modules/filter-expander"
import viviFilter from "./modules/vivi-filter"
import receptGalerijaSlider from "./modules/recepti-galerija-slider"
import anketaJs from "./modules/anketa"
import formGDPR from "./modules/form-gdpr"
import imageBlock from "./modules/image-block"
import otpEarlybird from "./modules/otp-earlybird"
import trgovinaLoad from "./modules/trgovina-load"
import wooQuantity from "./modules/woo-quantity"
import loginModal from "./modules/login-modal"
import lostPasswordModal from "./modules/lost-password"
import lostPasswordResetModal from "./modules/lost-password-reset"
import textareaAutoresize from "./modules/textarea-autoresize"
import formInputsManipulation from "./modules/form-inputs-manipulation"
import requiredFieldsRed from "./modules/required-fields"
import flatpickrPolja from "./modules/flatpickr-polja"
import sgNagradnaIgra from "./modules/sg-nagradna-popup"
import footerMailerlite from "./modules/footer-mailerlite"
import horizontalScrollNav from "./modules/horizontal-scroll-nav"
import sponsorsMarquee from "./modules/sponsors-marquee"
import prostiTerminiHours from "./modules/prosti-termini-hours"
import prostiTerminiMobile from "./modules/prosti-termini-mobile"


//Prijava TR
import googleTranslate from "./modules/prijava-tr/google-translate.js"
import passwordToggle from "./modules/prijava-tr/password-toggle.js"
import formaShowHide from "./modules/prijava-tr/forma-show-hide.js"
import formaShowHideMeni from "./modules/prijava-tr/forma-show-hide-meni.js"
import prijava1 from "./modules/prijava-tr/prijava-1.js"
import prijava3registracija from "./modules/prijava-tr/prijava-3-registracija.js"
import restavracijaTRdelovniCasSave from "./modules/prijava-tr/restavracija-tr-delovnicas-save"
import restavracijaTRmeniSave from "./modules/prijava-tr/restavracija-tr-meni-save"
import adminUrejanje from "./modules/prijava-tr/admin-urejanje"
import pdfMeniForm from "./modules/prijava-tr/pdf-meni-form"
import restavracijaTRvprasalnik from "./modules/prijava-tr/restavracija-tr-vprasalnik"
import restavracijaTRngStaropramen from "./modules/prijava-tr/restavracija-tr-ng-staropramen"
import floorplanUpload from "./modules/prijava-tr/floorplan-upload"


import trRezervacijaLinkParams from "./modules/tr-rezervacija-link-params"
import singleRestavracija from "./modules/single-restavracija" //legacy

$(function () {
	headerMenu.init()
	anchorScroll.init()
	horizontalScrollNav.init()
	sponsorsMarquee.init()
	prostiTerminiHours.init()
	prostiTerminiMobile.init()
	mobileMenu.init()
	cookieConsent.init()
	singleRegija.init()
	filtersMobileToggle.init()
	homeNewsSlick.init()
	restavracijeLoad.init()
	viviSelect.init()
	restavracijeGallerySlick.init()
	// restavracijaInviteSlick.init()
	restavracijaHeaderSlick.init()
	restavracijaFlotingButton.init()
	trRezervacijaLinkParams.init()
	restavracijaTRmenu.init()
	restavracijaPopupForm.init()
	restavracijaGalleryMagnific.init()
	newsLoad.init()
	chefsLoad.init()
	intersectionAnimations.init()
	infoPopup.init()
	singleRestavracija.init()
	filterExpander.init()
	viviFilter.init()
	receptGalerijaSlider.init()
	anketaJs.init()
	formGDPR.init()
	imageBlock.init()
	otpEarlybird.init()
	trgovinaLoad.init()
	wooQuantity.init()
	requiredFieldsRed.init()
	flatpickrPolja.init()
	sgNagradnaIgra.init()
	footerMailerlite.init()
	loginModal.init()
	lostPasswordModal.init()
	lostPasswordResetModal.init()
	textareaAutoresize.init()
	formInputsManipulation.capsLock()
	formInputsManipulation.preventSymbols()
	passwordToggle.init()
	googleTranslate.init()
	prijava1.init()
	prijava3registracija.init()
	restavracijaTRdelovniCasSave.init()
	restavracijaTRmeniSave.init()
	adminUrejanje.init()
	restavracijaTRvprasalnik.init()
	restavracijaTRngStaropramen.init()
	pdfMeniForm.init()


	formaShowHide.delovni_cas()
	formaShowHide.nacin_sprejemanja_rezervacij()
	formaShowHide.noShowOdpoved()
	formaShowHide.terminiDoSeating()
	floorplanUpload.init()
	formaShowHide.tip_rezervacijskega_sistema()
	formaShowHide.navodlilaImageMagnificPopup()
	formaShowHide.zaprtiDneviChecking()
	formaShowHideMeni.meni()
	formaShowHideMeni.lokalniDobavitelji()
	formaShowHideMeni.dodatniHodDoplacilo()
	formaShowHideMeni.vinarObveznaCena()
	formaShowHideMeni.vinskaSpremljava()
	formaShowHideMeni.dodatnaVinskaSpremljava()
	formaShowHideMeni.iksEnableDisable()
	formaShowHideMeni.dodatniChef()

})
